var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#113E89",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_978_21214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 25L18 27L20 29",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 27H27C27.3186 26.9836 27.6287 26.8912 27.9043 26.7305C28.1799 26.5698 28.4131 26.3456 28.5843 26.0764C28.7556 25.8073 28.86 25.501 28.8888 25.1833C28.9177 24.8656 28.8701 24.5456 28.75 24.25L28.2 23.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5343 18.9996L15.8023 16.2676L13.0703 16.9996",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8045 16.2676L11.3045 24.0616C11.1595 24.3457 11.0846 24.6603 11.086 24.9792C11.0873 25.2981 11.1649 25.6121 11.3123 25.8949C11.4597 26.1777 11.6726 26.4212 11.9332 26.605C12.1938 26.7888 12.4946 26.9077 12.8105 26.9516L13.9515 26.9756",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4648 19L26.1968 19.732L26.9288 17",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1947 19.7318L21.6947 11.9378C21.5211 11.6703 21.286 11.4481 21.0091 11.2899C20.7322 11.1316 20.4214 11.0419 20.1028 11.0282C19.7841 11.0145 19.4668 11.0772 19.1773 11.2111C18.8878 11.345 18.6346 11.5461 18.4387 11.7978L17.8477 12.7738",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_978_21214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.47bcc6da046ba21da3dba49263af0a8b.svg";
export { ForwardRef as ReactComponent };